import styled from 'styled-components';
import { BasicSelect, BaseOption, SelectWrapper } from 'ui/selects';
import { isBoolean, isDefined } from 'utils/tsHelpers';

import { Trigger } from './Trigger';
import { useTranslation } from '../../../hooks/useTranslation';
import { useConditionValueController, useConditionValueErrors } from '../../../hooks/form';
import { BooleanValue } from '../../../domain';

const StyledBasicSelect = styled(BasicSelect)`
  ${({ theme }) => theme.styles.body.body2};
  width: fit-content;
  ${SelectWrapper} {
    border: none;
    background: none;
    :hover {
      border-color: none;
    }
  }
`;

export const DATA_TEST = {
  select: 'condition-boolean-select',
};

export const BooleanSelect = () => {
  const { t } = useTranslation();
  const error = useConditionValueErrors();
  const {
    field: { value: defaultValue, onChange },
  } = useConditionValueController();

  const options: BaseOption<boolean>[] = [
    { id: 'boolean-option: true', label: t('selector.boolean.true'), value: true },
    { id: `boolean-option: false`, label: t('selector.boolean.false'), value: false },
  ];

  const defaultOption = options
    .filter(({ value }) => value === defaultValue?.value)
    .map(({ value }) => value);

  return (
    <StyledBasicSelect
      options={options}
      Trigger={Trigger}
      data-test={DATA_TEST.select}
      defaultValues={defaultOption}
      suffixUsed
      onSelect={([value]) => {
        if (isBoolean(value)) {
          onChange({ target: { value: new BooleanValue(value) } });
        }
      }}
      isError={isDefined(error)}
    />
  );
};
